<template>
  <div class="reconciliation">
    <div class="campus">
      财务管理
      <span>></span>
      <router-link to="reconciliation">财务对账</router-link>
    </div>
    <el-card>
      <div class="grid-content">
        <div class="header">学生端小程序付款信息</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <div class="dz-flex mb-20">
            <el-form-item label="日期：" prop="datime" class="dz-flex">
              <el-date-picker v-model="ruleForm.datime" type="daterange" :editable="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="手机号：" class="dz-flex ml-30">
              <el-input v-model="ruleForm.phoneNumber" placeholder="请输入用户手机号" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="ml-30" type="primary" @click="conditionSearch">查 询</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="reconciliation-content">
        <div class="reconciliation-content-bill dz-relative" v-for="(item,index) in billList" :key="index">
          <el-input v-model="billList[index]" type="textarea"  size="40px" autosize :readonly="true"></el-input>
          <!-- <el-button plain class="copy dz-f18" @click="copyBill(item)">复制</el-button> -->
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'reconciliation',
  data() {
    return {
      ruleForm: {
        phoneNumber: '',
        datime: [],
      },
      billList: [],
      rules: {
        datime: [
          {
            required: true,
            message: '请选择日期',
            trigger: 'change',
          },
        ],
      },
    };
  },
  created() {
    let today = new Date();
    let lastDay = today.getTime() - 24 * 60 * 60 * 1000 * 7;
    lastDay = new Date(lastDay);
    this.ruleForm.datime[0] = lastDay.getFullYear() + '-' + (lastDay.getMonth() + 1) + '-' + lastDay.getDate();
    this.ruleForm.datime[1] = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    this.searchBill();
  },
  methods: {
    conditionSearch() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          console.log('数据校验不通过');
          return false;
        }
        this.searchBill();
      });
    },
    searchBill() {
      let beginDate, endDate;
      if (!this.ruleForm.datime) {
        beginDate, (endDate = '');
      } else {
        beginDate = this.ruleForm.datime[0];
        endDate = this.ruleForm.datime[1];
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/pay-info/student/bill?beginDate=' + beginDate + '&endDate=' + endDate + '&phoneNumber=' + this.ruleForm.phoneNumber,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
            this.billList = result.data.data;
            this.$forceUpdate();
        })
        .catch((err) => {
          return this.$message.error('查询失败：' + err);
        });
    },
    copyBill(item){
      let div = document.createElement('div');
      div.innerHTML = '<span>' + item + '</span>';
      document.body.appendChild(div);
      let range = document.createRange();
      let selection = window.getSelection();
      selection.removeAllRanges();
      range.selectNodeContents(div);
      selection.addRange(range);
      document.execCommand('copy');
      selection.removeAllRanges();
      document.body.removeChild(div);
      this.$message.success('复制成功！');
    },
  },
};
</script>

<style lang="less" scoped>
.reconciliation {
  &-content {
    min-height: 500px;
  }
  &-content-bill {
    min-height: 125px;
    width:70vw;
    margin: 0 auto;
    padding: 25px;
    border: 2px solid ;
    border-radius: 30px;
      /deep/.el-textarea__inner{
        border: none;
        width: 70vw;
        font-size: 23px;
      }
      .copy{
        position: absolute;
        top: 20px;
        right: 20px;
        border: 1px solid;
        padding:3px 5px;
        border-radius: 5px;
      }
  }
}
</style>
